module.exports = __webpack_public_path__ + "static/media/colorGame.c06b8182.gif";